import type { SignupAttribution } from 'server/types';

const STORAGE_KEY = 'rz_signup_attribution';
const MAX_AGE_MS = 7 * 24 * 60 * 60 * 1000;

const PARAMS: Record<string, keyof SignupAttribution> = {
  rz_utm_source: 'utmSource',
  rz_utm_medium: 'utmMedium',
  rz_utm_campaign: 'utmCampaign',
  rz_utm_content: 'utmContent',
  rz_utm_term: 'utmTerm',
  rz_ref: 'referrerHost',
  rz_lp: 'landingPath',
  rz_seg: 'seg',
};

let memory: SignupAttribution | undefined;

function decode(value: string) {
  try {
    return decodeURIComponent(value.replace(/\+/g, ' '));
  } catch {
    return '';
  }
}

export function captureSignupAttribution() {
  try {
    const pairs = location.search.slice(1).split('&').filter(Boolean);
    const kept = pairs.filter((pair) => !(pair.split('=')[0] in PARAMS));
    if (kept.length === pairs.length) {
      return;
    }
    const attribution: SignupAttribution = {};
    for (const pair of pairs) {
      const [name, ...rest] = pair.split('=');
      const key = PARAMS[name];
      const value = key ? decode(rest.join('=')).trim().slice(0, 200) : '';
      if (key && value) {
        attribution[key] = value;
      }
    }
    const search = kept.length ? `?${kept.join('&')}` : '';
    history.replaceState(history.state, '', `${location.pathname}${search}${location.hash}`);
    if (!Object.keys(attribution).length) {
      return;
    }
    memory = attribution;
    localStorage.setItem(STORAGE_KEY, JSON.stringify({ attribution, t: Date.now() }));
  } catch {}
}

export function getSignupAttribution(): SignupAttribution | undefined {
  if (memory) {
    return memory;
  }
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    const stored = raw
      ? (JSON.parse(raw) as { attribution: SignupAttribution; t: number })
      : undefined;
    if (stored && Date.now() - stored.t <= MAX_AGE_MS) {
      return stored.attribution;
    }
    localStorage.removeItem(STORAGE_KEY);
  } catch {}
  return undefined;
}

export function clearSignupAttribution() {
  memory = undefined;
  try {
    localStorage.removeItem(STORAGE_KEY);
  } catch {}
}
